import { DevBox, FailureOnDevBox } from '../../models/dev-box';
import { DevBoxState } from '../store/dev-box-state';
import { createStringIdAdapter } from './common/string-id-adapter';

export const devBoxAdapter = createStringIdAdapter<DevBox>();
export const devBoxStateAdapter = createStringIdAdapter<DevBoxState>();
export const failureOnDevBoxAdapter = createStringIdAdapter<FailureOnDevBox>();
